__turbopack_context__.v({
  "container": "titleAndLink-module-scss-module__Ehi-5a__container",
});
